{
  "commonHeader": {
    "toggleSidebar": "Mostrar ou ocultar a barra lateral",
    "cartLoading": "A carregar o cesto de compras",
    "cart": "Cesto de compras",
    "aicForAdmin": {
      "ariaLabel": "IA para administradores"
    },
    "usersResults": "Utilizadores, {0} resultados",
    "settingsResults": "Definições, {0} resultados",
    "navigationResults": "Navegação, {0} resultados",
    "learnMoreAbout": "Saiba mais sobre {0}",
    "close": "Fechar",
    "products": "Produtos",
    "moreActions": "Mais ações",
    "search": "Pesquisar",
    "searchPlaceholderAll": "Pesquisar utilizadores, definições da conta ou navegação",
    "searchPlaceholderUsers": "Pesquisar utilizadores ou navegação",
    "searchPlaceholderSettings": "Pesquisar definições da conta ou navegação",
    "searchPlaceholderNav": "Pesquisar navegação"
  },
  "footerCopyright": {
    "language": "Idioma {0}"
  },
  "adminMenu": {
    "adminMenu": {
      "ariaLabel": "Menu de administrador"
    }
  },
  "shared": {
    "close": "Fechar",
    "sideMenu": {
      "personalAria": "Menu pessoal",
      "adminAria": "Menu de administrador",
      "mainNav": "Navegação principal",
      "submenu": "Submenu",
      "pinnedSection": "{0} afixado",
      "sideMenuAria": "Menu lateral",
      "pinItem": "Afixar {0}",
      "unpinItem": "Desafixar {0}",
      "reorderGrabbed": "Reordenar {0}, agarrado. Utilize as setas para cima e para baixo para mover, espaço ou Enter para largar, Escape para cancelar.",
      "reorderIdle": "Reordenar {0}. Prima espaço ou Enter para agarrar.",
      "hintHandlePin": "Prima Tab para aceder ao identificador de arrasto e ao botão de afixar",
      "hintHandle": "Prima Tab para aceder ao identificador de arrasto",
      "hintPin": "Prima Tab para aceder ao botão de afixar",
      "upgradeToPro": "Atualizar para Pro"
    },
    "item": "Item"
  },
  "coachMark": {
    "coachMark": {
      "tryNewExperienceAria": "Experimentar a nova experiência"
    }
  },
  "aicGuide": {
    "common": {
      "close": "Fechar"
    }
  },
  "divisionTips": {
    "coachMark": {
      "dvsTipsTitle": "As divisões estão agora disponíveis"
    }
  },
  "externalAccountTips": {
    "coachMark": {
      "extAccountTipsTitle": "Gerir contas externas"
    }
  },
  "zccRenameTips": {
    "coachMark": {
      "tipsTitle": "O livro de endereços passará a ser o diretório de clientes"
    }
  },
  "feedback": {
    "itemLableForProductArea": "Área do produto",
    "itemLableForFeedback": "Feedback"
  }
}
